import listViewStore from '../store/Store';
import createFocusedOtherDropViewState from '../actions/createFocusedOtherDropViewState';
export default function getFocusedOtherDropViewState() {
    if (!listViewStore.focusedOtherDropViewState) {
        createFocusedOtherDropViewState();
    }
    return listViewStore.focusedOtherDropViewState;
}
//# sourceMappingURL=getFocusedOtherDropViewState.js.map